export const AppColors = {
    base : {
        backgoundColor: "#ebebeb",
        fontColor: "#707070",
        fontwhite: "#ffffff"
    },
    decorative : {
        greenLight: "#24b895ff",
        greenDark: "#006b5cff",
        greenMidlle: "#1d9e8cff",
        blueLight: "#2695deff",
        blueDark: "#1f577d",
        blueMidlle: "#0071bc",
        purpleLight: "#71669fff",
        purpleLigther: "#7d7797",
        orangeLight: "#ce783fff",
        orangeLigther: "#d5af96",
        brownLight: "#72624f",
        redLight: "#db6161"
    }
}